import { useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { patchPortfolio, selectPortfolio } from '@/store/slices/portfolioSlice';

export function useScorecardInputs() {
  const dispatch = useDispatch();
  const portfolio = useSelector(selectPortfolio);
  const portfolioRef = useRef(portfolio);
  portfolioRef.current = portfolio;

  const patch = useCallback(
    (partialOrUpdater) => {
      const current = portfolioRef.current;
      const partial =
        typeof partialOrUpdater === 'function'
          ? partialOrUpdater(current)
          : partialOrUpdater;
      if (!partial || typeof partial !== 'object') return;
      dispatch(patchPortfolio(partial));
    },
    [dispatch]
  );

  const makeFieldSetter = useCallback(
    (key) => (valueOrUpdater) => {
      const current = portfolioRef.current;
      const next =
        typeof valueOrUpdater === 'function'
          ? valueOrUpdater(current[key])
          : valueOrUpdater;
      dispatch(patchPortfolio({ [key]: next }));
    },
    [dispatch]
  );

  return {
    portfolio,
    patch,
    setFromYear: makeFieldSetter('fromYear'),
    setToYear: makeFieldSetter('toYear'),
    setYearsList: makeFieldSetter('yearsList'),
    setSelectedType: makeFieldSetter('selectedType'),
    setFirstAsset: makeFieldSetter('firstAsset'),
    setFirstAssetName: makeFieldSetter('firstAssetName'),
    setSecondAsset: makeFieldSetter('secondAsset'),
    setSecondAssetName: makeFieldSetter('secondAssetName'),
    setInsuranceSliderValue: makeFieldSetter('insuranceSliderValue'),
    setLock: makeFieldSetter('lock'),
    setRegimeCount: makeFieldSetter('regimeCount'),
    setRegimeSelectors: makeFieldSetter('regimeSelectors'),
    setAlloc: makeFieldSetter('alloc'),
    setPercentileDropdown: makeFieldSetter('percentileDropdown'),
    // multi
    setAssets: makeFieldSetter('assets'),
    setActiveAsset: makeFieldSetter('activeAsset'),
    setSecondAssets: makeFieldSetter('secondAssets'),
    setSecondAssetNames: makeFieldSetter('secondAssetNames'),
    setInsuranceSliderValues: makeFieldSetter('insuranceSliderValues'),
    setAllocByAsset: makeFieldSetter('allocByAsset'),
    setPin: makeFieldSetter('pin'),
    setAllocLock: makeFieldSetter('allocLock'),
    setPercentile1Dropdown: makeFieldSetter('percentile1Dropdown'),
    setPercentile2Dropdown: makeFieldSetter('percentile2Dropdown'),
  };
}
